export type Question = {
    question: string
}

export type TopQuestionsResponse = {
    questions: Array<Question>
}

export type Suggestion = {
    suggestion: string
}

export type SuggestionsResponse = {
    suggestions: Array<Suggestion>
}

export type Reference = {
    index: number
    title: string
    url: string
    content: string
}

export type SummaryResponse = {
    status: "success" | "no-relevant-results"
    summary: string
    references: Array<Reference>
}

export type SearchResult = {
    type: "paragraph" | "instant_answer"
    title: string
    content: string
    url: string
    preview_url: string
    feedback_data: string
    metadata: Record<string, unknown>
    configuration: Record<string, unknown>
}

export type SearchResultsResponse = {
    results: Array<SearchResult>
}

export const fetchTopQuestions = async (uid: string) => {
    const response = await fetch(
        "https://api.raffle.ai/v2/top_questions?uid=" + uid
    )
    return await response.json() as TopQuestionsResponse
}

export const fetchSummary = async (uid: string, query: string) => {
    const response = await fetch(
        `https://api.raffle.ai/v2/summary?uid=${uid}&query=${query}`
    )
    return await response.json() as SummaryResponse
}

export type Device = "desktop" | "mobile" | "unknown"

export const fetchSearchResults = async (uid: string, query: string, device: Device, session_id: string) => {
    const response = await fetch(
        `https://api.raffle.ai/v2/search?uid=${uid}&query=${query}&device=${device}&session-id=${session_id}`
    )
    return await response.json() as SearchResultsResponse
}
